/**
 * Declaration order is display order: UNIT_TYPES is derived from it and drives
 * the garrison strip, the muster roll and every unit table. Grouped as
 * infantry, then ranged, then horse, then siege, then the Bailiff.
 */
export const UnitType = {
    SPEARMAN: 'spearman',
    SWORDSMAN: 'swordsman',
    AXEMAN: 'axeman',
    MILITIA_ARCHER: 'militia_archer',
    ARCHER: 'archer',
    CROSSBOWMAN: 'crossbowman',
    SCOUT: 'scout',
    LIGHT_CAVALRY: 'light_cavalry',
    HEAVY_CAVALRY: 'heavy_cavalry',
    KNIGHT: 'knight',
    RAM: 'ram',
    CATAPULT: 'catapult',
    CANNON: 'cannon',
    BAILIFF: 'bailiff',
    COG: 'cog',
    LONGSHIP: 'longship',
    WAR_GALLEY: 'war_galley',
};
export const UNIT_TYPES = Object.values(UnitType);
/**
 * Combat class decides *which* defence stat of the defender applies.
 * An attacking `cavalry` unit is met by the defender's `defCavalry`, etc.
 */
export const UnitClass = {
    INFANTRY: 'infantry',
    ARCHER: 'archer',
    CAVALRY: 'cavalry',
    SIEGE: 'siege',
    SPECIAL: 'special',
    /**
     * Ships. They never meet land units: a naval clash is resolved on its own,
     * before anyone reaches the beach, so a hull's three defence stats are all
     * the same number and only the naval resolver reads them.
     */
    NAVAL: 'naval',
};
export const MovementType = {
    ATTACK: 'attack',
    RAID: 'raid',
    SUPPORT: 'support',
    SCOUT: 'scout',
    RETURN: 'return',
};
//# sourceMappingURL=military.js.map